import { notifyUser } from './states';

export const services = {
  notifyUser,
};
